import Service from '@ember/service';

export default class MockTimeService extends Service {
    mockTime?: Date = undefined;
}
